import { z } from 'zod';
import { api } from './api';
import { categorySchema, type FinancialCategoryItem } from '@/types/schemas';

export const categoriesService = {
  list: (signal?: AbortSignal): Promise<FinancialCategoryItem[]> =>
    api.get('/categories', z.array(categorySchema), signal),
};
